module.exports = __webpack_public_path__ + "static/media/multi_samples_animation.40c564d7.gif";